<template>
  <Badge :label="statusLabel" :color="statusColor" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Badge } from '@exfluential/ui';
import { UserProgressStatus, useProgressStatusLabelMap } from '~/api/learning';
import { getProgressStatusBadgeColor } from '~/components/learning/progress-status';

type Props = {
  status: UserProgressStatus;
};

const props = defineProps<Props>();

const statusLabelMap = useProgressStatusLabelMap();

const statusColor = computed(() => getProgressStatusBadgeColor(props.status));
const statusLabel = computed(() => statusLabelMap.value[props.status]);
</script>
